import React from 'react'
import axios from "axios";
import Tableproduit from "./component/tableproduit"
import { useNavigate,Link } from "react-router-dom";
import Sidebar from './component/Sidebar';
import AdminUserBadge from './component/AdminUserBadge';
  class Produit extends React.Component{

    

  render() {
  return (
    <div>
     <div><Sidebar/></div>
  <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg " style={{marginLeft: "260px"}}>
    {/* Navbar */}
  
  {/* Navbar */}
  <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div className="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
            <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Produit</li>
          </ol>
          <h6 className="font-weight-bolder mb-0">Gestion Produit</h6>
        </nav>
        <div className="collapse justify-content-end navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
          <ul className="navbar-nav justify-content-end align-items-center">
            <li className="nav-item d-flex align-items-center">
              <Link to="/ajoutproduit" className="btn btn-outline-primary btn-sm mb-0 me-3"> + Ajouter</Link>
            </li>
            <AdminUserBadge className="me-3" />
            <li className="nav-item d-flex align-items-center">
              <Link to="/login" className="nav-link text-body font-weight-bold px-0">
                <i className="fa fa-user me-sm-1" />
                <span className="d-sm-inline d-none">Deconnexion</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    {/* End Navbar */}
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header pb-0">
              <h6>Table produit</h6>
         
            </div>
            <div className="card-body px-0 pt-0 pb-2">
              <div className="table-responsive p-0">
               
<Tableproduit test="ok"/>

              </div>
            </div>
          </div>
        </div>
      </div>
     
      <footer className="footer pt-3  ">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                © SEFIR.
              </div>
            </div>
        
          </div>
        </div>
      </footer>
    </div>
  </main>
  
</div>

   
  )
}
  }
export default Produit

